export enum AppRoutes {
  Enrollment = '/',
  Home = '/home',
  Data = '/data',
  Reminder = '/home/reminder',
  DoctorAppointment = '/home/doctor-appointment',
  MigraineAttack = '/home/attack',
  VyduraIntake = '/home/vydura-intake',
  Calendar = '/home/calendar',
}
